/*
 * Copyright (c) 2019, F5 Networks, Inc. All rights reserved.
 *
 * No part of this software may be reproduced or transmitted in any
 * form or by any means, electronic or mechanical, for any purpose,
 * without express written permission of F5 Networks, Inc.
 */
import * as React from 'react';
import ITemplateModel from './Model';
import HeaderControls from './HeaderControls';

class PageHeader extends React.Component<ITemplateModel['general']> {
    render() {
        return (
            <header className="apmui-header">
                <div className="apmui-header--content">
                    <picture className="apmui-header--logo">
                        <source
                            media={`(max-width: ${this.props.config.layoutBreakpointSmall})`}
                            srcSet={this.props.header.logoSmallImage}
                        />
                        <img src={this.props.header.logoImage} alt="" />
                    </picture>
                    <span>{this.props.header.mottoMessage}</span>
                    {this.props.header.showControls && <HeaderControls {...this.props.header} />}
                </div>
            </header>
        );
    }
}

export default PageHeader;
